import Modal from 'components/Modals';
import styled from '@emotion/styled';

export const StyledModal = styled(Modal)`
  .modal-content {
    height: 100%;
    max-height: 500px;
  }
`;
